import React from 'react'
import { useSubPages } from '../uses/useSubPages'
import SPPatients from './graphs/SPPatients'
// import SPProfile from './graphs/SPProfile'
import SPOrigine from './graphs/SPOrigine'

const SoinsPaliatifsGraph = ({ page }) => {
  switch (page.slug) {
    case 'patients-et-prestations':
      return <SPPatients page={page} />
    // case 'profil-diagnostic':
    //   return <SPProfile page={page} />
    case 'origine':
      return <SPOrigine page={page} />
    default:
      return null
  }
}

const SoinsPaliatifsContent = ({ page }) => {
  return (
    <section>
      {useSubPages(page.wordpress_id).map((item, index) => (
        <SoinsPaliatifsGraph key={index} page={item} />
      ))}
    </section>
  )
}

const SoinsPaliatifs = ({ page }) => (
  <div className="text-content accordion-content">
    <div
      className="headlines"
      dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
    />
    <div
      className="event-media media-text"
      dangerouslySetInnerHTML={{ __html: page.content }}
    />
    <SoinsPaliatifsContent page={page} />
  </div>
)

export default SoinsPaliatifs
